const useOptions = () => {

    const getEarnAndBurnOptions = () => [
        { value: 'any', label: 'Any' },
        { value: 'burn-to-earn', label: 'Burn to Earn' },
        { value: 'earn-and-burn', label: 'Earn and Burn' },
        { value: 'earn-to-burn', label: 'Earn to Burn' },
    ];

    const getEarnBurnOrderOptions = () => [
        { value: 'earn-then-burn', label: 'Earn (1) - Burn (2)' },
        { value: 'burn-then-earn', label: 'Burn (1) - Earn (2)' },
    ];

    const getRoundingOptions = () => [
        { value: 'Ceiling', label: 'Ceiling' },
        { value: 'Down', label: 'Down' },
        { value: 'Floor', label: 'Floor' },
        { value: 'HalfDown', label: 'HalfDown' },
        { value: 'HalfEven', label: 'HalfEven' },
        { value: 'HalfUp', label: 'HalfUp' },
        { value: 'NearestHalf', label: 'NearestHalf' },
        { value: 'Unnecessary', label: 'Unnecessary' },
        { value: 'Up', label: 'Up' },
    ];

    return {
        getEarnAndBurnOptions,
        getEarnBurnOrderOptions,
        getRoundingOptions,
    };
};

export default useOptions;
